export default "__VITE_ASSET__BR4QAY08__"